import { Component } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { BdbSessionStrgService } from '@npm-bbta/bbog-cm-auth-lib';
import { SessionStorageKeysEnum } from '../models/session-storage-keys-enum';
import { RedirectService } from '../shared/redirect.service';

@Component({
    selector: 'app-bdb-expedition-date',
    templateUrl: './bdb-expedition-date.component.html',
    styleUrls: ['./bdb-expedition-date.component.scss']
})
export class BdbExpeditionDateComponent {

    expdateForm = new FormGroup({
        expday: new FormControl('',
            [
                Validators.required,
                Validators.min(1),
                Validators.max(31),
                Validators.minLength(2)
            ]
        ),
        expmonth: new FormControl('',
            [
                Validators.required,
                Validators.min(1),
                Validators.max(12),
                Validators.minLength(2)
            ]
        ),
        expyear: new FormControl('',
            [
                Validators.required,
                Validators.min(1900),
                Validators.max(new Date().getFullYear()),
                Validators.minLength(4)
            ]
        )
    });

    constructor(
        private readonly bdbSessionStrgService: BdbSessionStrgService,
        private readonly router: Router,
        private readonly redirectService: RedirectService,
    ) {}

    get expday() {
        return this.expdateForm.get('expday')
    }

    get expmonth() {
        return this.expdateForm.get('expmonth')
    }

    get expyear() {
        return this.expdateForm.get('expyear')
    }
    onSubmit() {
        this.bdbSessionStrgService.save(SessionStorageKeysEnum.EXPDATE, JSON.stringify(this.expdateForm.value));
        this.router.navigate(['regulation-rnec']);
    }
    onExit() {
        this.redirectService.quit();
    }
    onBack() {
        this.router.navigate([history.back()]);
    }
    check($event) {
        const el = $event.target as HTMLInputElement;
        const val = this.expdateForm.get(el.id).value;
        if (val.length === 1) {
            this.expdateForm.get(el.id).setValue(`0${val}`);
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/bdb-expedition-date/bdb-expedition-date.component.ts